import { useCallback, useState } from "react";

interface UseSelectedModeResult {
  selectedModeId: string | null;
  /** Select a mode, or toggle it off when it is already selected. */
  selectMode: (id: string) => void;
  clearMode: () => void;
}

/**
 * Selection state for the cluster map ↔ legend ↔ detail panel (design doc 015
 * §6). Selecting a mode highlights it on the map and opens its detail panel;
 * re-selecting the same mode clears it.
 */
export function useSelectedMode(): UseSelectedModeResult {
  const [selectedModeId, setSelectedModeId] = useState<string | null>(null);

  const selectMode = useCallback((id: string) => {
    setSelectedModeId((current) => (current === id ? null : id));
  }, []);

  const clearMode = useCallback(() => setSelectedModeId(null), []);

  return { selectedModeId, selectMode, clearMode };
}
